
export const environment = {
   production: true,
   ribbon: undefined,
   environment: 'production',
   buildTimestamp: 1746895384763,
   ssoUrl: 'https://auth.cirqus.de',
   commitHash: '2ec9386916b1e2ea13d4d4b1bf200d14287a08c6',
};
